import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink} from "@angular/router";
import {HeroSectionComponent} from "./hero-section.component";

@NgModule({
    declarations: [HeroSectionComponent],
    imports: [
        CommonModule,
        RouterLink
    ],
    exports: [
        HeroSectionComponent
    ]
})
export class HeroSectionModule {
}
